




























































import Vue from "vue";
import faqData from "@/data/faq_data";
import Metro from "@/new_assets/metro.png";

export default Vue.extend({
  name: "Faq",
  props: ["initialSelect", "billboardPic"],
  data() {
    return {
      faqData,
      selected: "",
      expanded: [0],
      Metro,
    };
  },
  methods: {
    isMobile: (): boolean => window.innerWidth <= 720,
    toggleQuestion(index: number) {
      if (!this.expanded.includes(index)) {
        this.expanded.push(index);
      } else {
        this.expanded = this.expanded.filter((each) => each !== index);
      }
    },
    selectCategory(name: string) {
      if (this.selected !== name) {
        this.selected = name;
        this.expanded = [0];
      } else {
        if (this.isMobile()) {
          this.selected = "";
        }
      }
    },
  },
  created(): void {
    this.selected = this.initialSelect;
  },
});
